import { useSyncExternalStore } from "react";

function subscribe(listener: () => void) {
  window.addEventListener("online", listener);
  window.addEventListener("offline", listener);
  return () => {
    window.removeEventListener("online", listener);
    window.removeEventListener("offline", listener);
  };
}

function snapshot() {
  return typeof navigator === "undefined" || navigator.onLine !== false;
}

/** Browser connectivity as a surface state input. A lost connection is its own
 *  state — it must never be read as the end of a Try. */
export function useOnlineStatus(): boolean {
  return useSyncExternalStore(subscribe, snapshot, () => true);
}
